export default {
  validateRoute(toName, routes) {
    let isValidRoute = false;

    isValidRoute = routes.filter((r) => r.name).some((r) => r.name === toName);
    isValidRoute = isValidRoute || routes.filter((r) => r.children).some((r) => this.validateRoute(toName, r.children));

    return isValidRoute;
  },
};
